import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function StreakCard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/progress/streak").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const flame = s.current_streak > 0;
  return (
    <div data-testid="streak-card" className={`border rounded-md p-6 ${flame ? "border-red-700 bg-gradient-to-br from-neutral-900 to-red-950/40" : "border-neutral-800 bg-neutral-900"}`}>
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="uppercase text-xs text-neutral-400 font-display tracking-widest">Streak</div>
          <div className="mt-1 font-display-heavy text-5xl">
            <span className={flame ? "text-red-500" : ""}>{s.current_streak}</span>
            <span className="text-neutral-500 text-xl font-normal ml-2">days</span>
          </div>
        </div>
        {flame && <div data-testid="streak-flame" className="text-5xl leading-none">🔥</div>}
      </div>
      <div className="mt-3 text-sm">
        {s.at_risk_today ? (
          <span data-testid="streak-at-risk" className="text-yellow-400">⚠ Do a drill today to keep the chain alive.</span>
        ) : s.current_streak > 0 ? (
          <span className="text-neutral-400">Done for today. Longest run: <span className="text-white">{s.longest_streak} days</span>.</span>
        ) : (
          <span className="text-neutral-400">Start a chain — mark any drill done to begin.</span>
        )}
      </div>
    </div>
  );
}
